<template>
  <div>
    <Button
      type="button"
      class="btn btn-primary"
      :disabled="campaign.status == 'FINISHED'"
      :loading="loader"
      @click="submit"
    >
      Sincronizar campanha com DV360
    </Button>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import NotificationService from '@/modules/notifications/services/notifications-service'

export default {
  name: 'SyncCampaignDv360Button',
  props: ['campaign'],
  components: {
    Button
  },
  data () {
    return {
      loader: false
    }
  },
  created () {
  },
  methods: {
    /**
     * Submit form
     */
    async submit () {
      this.loader = true
      try {
        await CampaignsService.syncCampaign(this.campaign.id)

        const notification = {
          notification: {
            type: 'success',
            content: 'Campanha sincronizada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
